import { notification, Tabs, TabsProps } from "antd";
import React from "react";
import LocationsApi from "../../api-services/locations-api.service";
import { Country } from "../../interfaces/country.interface";
import { mdiMenuRight } from "@mdi/js";
import Icon from "@mdi/react";
import { Link } from "react-router-dom";
import LocationPostcards from "./shared/LocationPostcards";
import LocationDropdown from "./shared/LocationDropdown";

interface IDestinationState {
  countries: Country[],
  selectedCountry: any,
  activeTab: string;
}


export default class Destinations extends React.Component {
  api = new LocationsApi;

  state:IDestinationState = {
    countries: [],
    selectedCountry: {}, 
    activeTab: "1"
  }

  componentDidMount() {
    this.api.getCountries()
      .then(locationsData => {
        this.setState({countries: locationsData, selectedCountry: locationsData[0]})
      })
      .catch(error => {
        notification.error({ message: 'An error occured while loading countries.'});
      });
  }

  changeTab (selectedCountryId) {
   const countries = this.state.countries;
   const selectedCountry = countries.find(c => c.id == +selectedCountryId);
   if(selectedCountry) this.setState({selectedCountry});

   this.setState({activeTab:selectedCountryId.toString()})
 }

  render(){
    const pluralize = (count: number, noun: string, suffix = 's') =>
      `${count} ${noun}${count > 1 ? suffix : ''}`;

    const listingLink = (locationId: number) => {
      return `/web/listing?location_id=${locationId}`;
    }


    var items:TabsProps["items"] = this.state.countries.map((country:Country, index)=>{
      return {
        key: country.id.toString(),
        label: <>
          {country.name}
        </>,
        children: (
          <div>
            <Link to={listingLink(country.id)} className="country">
              <img className="country-image" src={`${country.cover}`} />
              <h1 className="country-name"> {country.name} </h1>
              <picture className="bottom-logo">
                <img src="/iceholidays-assets/images/destinations_logo.png"></img>
              </picture>
            </Link>
            {
              country.topCities?.length > 0 && 
              <div className="top-cities">
                <h2>Top Cities</h2>
                <LocationPostcards locations={country.topCities}/>
              </div>
            }
            {
              country.tags?.length > 0 && 
              <div className="more-cities">
                <h2>Browse more {country.name} destination</h2>
                <div className="other-destinations">  
                  {
                    country.tags?.map((city, index)=>{
                      return <Link key={index} to={listingLink(city.id)}> {city.name} </Link>
                    })
                  }
                </div>
              </div>
            }

            {
              country.highlights?.length > 0 && 
                <div className="highlights">  
                  {
                    country.highlights?.map((city, index)=>{
                      return <Link key={index} to={listingLink(city.id)}>
                        <div className="tour" style={{backgroundImage:`linear-gradient(180deg, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.8) 100%), url("${city.cover}")`}}>
                          <div className="details"> 
                            <span className="city-name"> {city.name}  </span>
                            <span className="tour-count"> {pluralize(city.tourCount || 0, "tour")} <Icon path={mdiMenuRight} size={1} /> </span>
                          </div>
                        </div>
                      </Link>
                    })
                  }
                </div>
            }
          </div>
        )
      }
    })

    return (
      <div id="popular-destinations">
        <h1>Explore Popular Destination</h1>

        <LocationDropdown initialValue={this.state.selectedCountry?.name} locations={this.state.countries} selectLocation={(selected)=>this.changeTab(selected)}/>

        <Tabs 
          defaultActiveKey="1" 
          activeKey={this.state.activeTab}
          items={items}
          type="card"
          onChange={(selected)=>this.changeTab(selected)}/>

      </div>
    )
  }
}